// "Updated 2 minutes ago" — RON-5469. Prototype region: the footbar's freshness line.
//
// §9 says to poll `GET /board` for now, and `as_at` is returned so the desk can see how stale the
// board is. A raw timestamp makes the reader subtract; "how long ago" is the question they
// actually have.
//
// It TICKS. A relative time rendered once is worse than a timestamp — it says "just now" for as
// long as the tab is open, which is a confident lie. Thirty seconds is fine granularity for a
// label that rounds to minutes anyway.

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { formatRelativeTime, pluralText } from "../receptionConstants.js";

const TICK_MS = 30000;

const ReceptionFreshness = ({ asAt }) => {
  const { t } = useTranslation("common");
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!asAt) return undefined;

    const timer = setInterval(() => setNow(Date.now()), TICK_MS);

    return () => clearInterval(timer);
  }, [asAt]);

  // Re-read the moment a new board lands, rather than waiting up to 30s for the next tick to say
  // so — a refresh should show as fresh immediately.
  useEffect(() => setNow(Date.now()), [asAt]);

  const relative = formatRelativeTime(asAt, now);
  if (!relative) return null;

  return (
    <span className="reception-foot__asat">
      {t("react_reception_updated")}{" "}
      {/* The machine-readable value stays in the markup even though the words are what is shown,
          so the exact moment is still available to anything reading the page. */}
      <time dateTime={asAt}>
        {relative.value === null
          ? t(relative.key)
          : pluralText(t, relative.key, relative.value)}
      </time>
    </span>
  );
};

export default ReceptionFreshness;
